import React from 'react';
import { Icon } from 'ksnm-common-ui/lib/Icon';
import type { ColumnInterface } from 'ksnm-common-ui/lib/Table2/Table.interface';

import { TABS } from '@stores/dictionaryStores/counterpartiesStore/counterpartiesStore';

export const getColumns = (tab: string): ColumnInterface[] => [
  {
    title: 'Организация (локальный справочник)',
    key: 'org_local_out',
    width: 300,
    hidden: tab === TABS.COMPANIES_CM,
  },
  {
    title: 'Код контрагента',
    key: 'code',
    width: 200,
  },
  {
    title: 'Наименование',
    key: 'name',
    width: 300,
  },
  {
    title: 'ИНН',
    key: 'inn',
    width: 200,
  },
  {
    title: 'КПП',
    key: 'kpp',
    width: 200,
  },
  {
    title: 'Признак налогового резидента',
    key: 'resident',
    width: 200,
    render: ({ value }) => value && <Icon name="check" />,
  },
  {
    title: 'Код в стране регистрации',
    key: 'taxpayer_code',
    width: 400,
  },
  {
    title: 'Фамилия',
    key: 'last_name',
    width: 200,
  },
  {
    title: 'Имя',
    key: 'first_name',
    width: 200,
  },
  {
    title: 'Отчество',
    key: 'middle_name',
    width: 200,
  },
  {
    title: 'Дата начала действия записи',
    key: 'start_date',
    width: 200,
  },
  {
    title: 'Дата окончания действия записи',
    key: 'end_date',
    width: 200,
  },
  {
    title: 'Тип контрагента',
    key: 'cp_type_code_out',
    width: 200,
  },
  {
    key: 'unique_id',
    hidden: true,
  },
  {
    key: 'counterparty',
    hidden: true,
  },
  {
    key: 'org_local',
    hidden: true,
  },
  {
    key: 'counterparty_type_code',
    hidden: true,
  },
];
